export const SSO_AUTH_METHOD = {
    NONE: "none",
    CLIENT_SECRET_POST: "client_secret_post",
    PRIVATE_KEY_JWT: "private_key_jwt",
}

export interface SsoConfigPayload {
    domain: string,
    partnerId: number,
    issuerUrl: string,
    clientId: string,
    authMethod: string,
    clientSecret: string | null
}

export interface DeleteSsoConfigPayload {
    domain: string,
    partnerId: number
}

export interface SsoConfigDetail {
    domain: string,
    partnerId: number,
    issuerUrl: string,
    clientId: string,
    provider: string,
    authMethod: string,
    clientSecret: string | null
}

export interface SsoConfigSaveResponse {
    redirectUrl: string,
    jwksUrl: string
}
